import React, { useState, useRef, useEffect } from 'react'
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import ReactCrop, { makeAspectCrop, centerCrop, convertToPixelCrop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import {
    Avatar, Badge, Dialog, DialogTitle, DialogContent,
    DialogContentText, IconButton, Snackbar, Button, TextField, Slider
} from "@mui/material";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CloseIcon from '@mui/icons-material/Close'; // Import close icon
import useApi from '../../../Utilities/useAPI';
import { getAllCardDetailsReducer, getAllCardInfoReducer } from '../../../../Redux/Reducers/CardReducer';
import { useDispatch } from 'react-redux';
import { useQuantityContext } from '../../../QuantityContext';

const ASPECT_RATIO = 1;
// let MIN_DIMENSION = 100;

const LightBoxGroupCreate = ({ setFamilyCardCreate, familyCardCreate }) => {
    const [cardDetails, setCardDetails] = useState({
        profilePic: '',
        groupName: '',
        description: ''
    });

    const dispatch = useDispatch();

    useEffect(() => {  //for resetting when Opened or Closed
        setCardDetails({
            profilePic: '',
            groupName: '',
            description: ''
        })
    }, [familyCardCreate])

    const { callApiFunction } = useApi();
    const [selectedImage, setSelectedImage] = useState(null);
    // const [crop, setCrop] = useState({
    //     unit: '%',
    //     width: 100,
    //     aspect: ASPECT_RATIO
    // });
    const [crop, setCrop] = useState({ unit: '%', x: 0, y: 0, width: 50, height: 50 });

    const [zoom, setZoom] = useState(1);
    const [MIN_DIMENSION, setMinDimension] = useState(100);
    const [croppedImage, setCroppedImage] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const { handleFailure, handleInfo } = useQuantityContext();

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setSelectedImage(imageUrl);
            setSelectedFile(file);
            setOpenDialog(true);
        }
    };

    const onImageLoad = (e) => {
        const { width, height } = e.currentTarget;
        const cropWidthInPercent = (MIN_DIMENSION / (width * zoom)) * 100; // Adjust for zoom level
        const newCrop = makeAspectCrop(
            { unit: "%", width: cropWidthInPercent },
            ASPECT_RATIO,
            width * zoom,
            height * zoom
        );
        const centeredCrop = centerCrop(newCrop, width, height);
        setCrop(centeredCrop);
    };



    // const handleCropSave = () => {
    //     if (!crop || !imgRef.current) return;

    //     const canvas = previewCanvasRef.current;
    //     const ctx = canvas.getContext("2d");
    //     const pixelCrop = convertToPixelCrop(crop, imgRef.current.width, imgRef.current.height);

    //     canvas.width = pixelCrop.width;
    //     canvas.height = pixelCrop.height;

    //     // Clear canvas and draw the rectangular cropped image
    //     ctx.clearRect(0, 0, canvas.width, canvas.height);
    //     ctx.scale(zoom, zoom); // Apply zoom factor

    //     // Draw the rectangular cropped image (without circular clipping)
    //     ctx.drawImage(
    //         imgRef.current,
    //         pixelCrop.x / zoom,
    //         pixelCrop.y / zoom,
    //         pixelCrop.width / zoom,
    //         pixelCrop.height / zoom,
    //         0,
    //         0,
    //         pixelCrop.width,
    //         pixelCrop.height
    //     );

    //     // Get the data URL for the rectangular cropped image
    //     const croppedImageDataUrl = canvas.toDataURL();
    //     setCroppedImage(croppedImageDataUrl);

    //     // Create a new file from the cropped image data URL
    //     const croppedFile = new File([dataURLtoBlob(croppedImageDataUrl)], selectedFile.name || 'croppedImage.jpg', {
    //         type: selectedFile.type || 'image/jpeg',
    //     });

    //     const imageObject = {
    //         name: croppedFile.name,
    //         type: croppedFile.type,
    //         data: URL.createObjectURL(croppedFile),
    //     };
    //     setOpenDialog(false);
    //     handleFileUpload(selectedFile);
    // };



    const dataURLtoBlob = (dataURL) => {
        const [header, data] = dataURL.split(',');
        const mime = header.match(/:(.*?);/)[1];
        const binStr = atob(data);
        const len = binStr.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binStr.charCodeAt(i);
        }
        return new Blob([bytes], { type: mime });
    };

    const handleCropSave = () => {
        if (!crop?.width || !crop?.height || !imgRef.current || !previewCanvasRef.current) return;

        const canvas = previewCanvasRef.current;
        const ctx = canvas.getContext("2d");

        const pixelCrop = convertToPixelCrop(crop, imgRef.current.naturalWidth, imgRef.current.naturalHeight);

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.drawImage(
            imgRef.current,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );

        const croppedImageDataUrl = canvas.toDataURL("image/jpeg");

        setCroppedImage(croppedImageDataUrl);

        const croppedFile = new File([dataURLtoBlob(croppedImageDataUrl)], selectedFile.name || 'cropped.jpg', {
            type: selectedFile.type || 'image/jpeg',
        });

        const imageObject = {
            name: croppedFile.name,
            type: croppedFile.type,
            data: URL.createObjectURL(croppedFile),
        };

        setOpenDialog(false);
        handleFileUpload(croppedFile); // ⚠️ previously was passing `selectedFile` — now pass cropped
    };



    const handleFileUpload = async (file) => {
        try {
            // const formData = new FormData();
            // formData.append('file', file);

            // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
            //     headers: {
            //         'Content-Type': 'multipart/form-data'
            //     }
            // });

            // const sasUrl = response.data.url;
            const fileurl = URL.createObjectURL(file);
            setCardDetails((prevState) => ({
                ...prevState,
                profilePic: fileurl
            }));
        } catch (error) {
            console.error('Error uploading file:', error.message);
            handleInfo('Error uploading file. Please check the console for details.');
        }
    };


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setCardDetails((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSliderChange = (event, newValue) => {
        setZoom(newValue);
        if (imgRef.current) {
            onImageLoad({ currentTarget: imgRef.current });
        }
    };
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar state
    const [snackbarMessage, setSnackbarMessage] = useState({ title: '', body: '' }); // Snackbar message with title and body

    const handleCreateGroupCard = async () => {
        // Prepare the payload
        // const payload = {
        //     group_name: cardDetails.groupName,
        //     group_subname: "Family Group",
        //     group_type: "FAMILY",
        //     group_desc: cardDetails.description,
        //     group_category: "FAMILY",
        //     profile_pic: cardDetails.profilePic
        // };

        const viewerToken = localStorage.getItem('objectId')?.trim(); // Retrieve token from localStorage
        const apiKey = process.env.REACT_APP_API_KEY; // Get API key from environment variable

        const headers = {
            'x-api-key': apiKey,
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${viewerToken}` // Add the token as Bearer
        };

        const formData = new FormData();
        formData.append("group_name", cardDetails.groupName)
        formData.append("group_subname", "Family Group")
        formData.append("group_type", "FAMILY");
        formData.append("group_desc", cardDetails.description);
        formData.append("group_category", "FAMILY");



        if (cardDetails.profilePic) {
            try {
                const response = await fetch(cardDetails.profilePic);  // Fetch blob
                const blob = await response.blob();             // Convert to blob
                // const file = new File([blob], attachment.name, { type: attachment.type }); // Create File object

                // Append as binary file
                formData.append("profile_pic", blob)
            } catch (error) {
                console.error("Error converting blob to file:", error);
            }
        }

        // for (let pair of formData.entries()) {
        //     console.log(pair[0], pair[1]); // Log keys and values to verify content
        // }
        try {
            // const response = await callApiFunction('createGroupCard', formData);
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/group-card/create`, formData, { headers });
            // console.log("Group response", response);
            if (response.status === 200) {
                const groupId = response.data?.data?.group_id;
                // console.log("Group ID response", groupId);
                setSnackbarMessage({
                    title: 'Success',
                    body: 'Group created successfully!'
                });
                setSnackbarOpen(true);
                navigate(`/familyCard/${groupId}`);

                await dispatch(getAllCardDetailsReducer());
                await dispatch(getAllCardInfoReducer());
            } else {
                // Show error snackbar
                setSnackbarMessage({
                    title: 'Failed',
                    body: 'Failed to create group.'
                });
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error('Error while creating group:', error);
            setSnackbarMessage({
                title: 'Error',
                body: 'An error occurred while creating the group.'
            });
            setSnackbarOpen(true);
        }
    };

    // Function to close the Snackbar
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const isFormValid = cardDetails.profilePic && cardDetails.groupName && cardDetails.description;
    return (
        <>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                message={
                    <div>
                        <strong>{snackbarMessage.title}</strong>
                        <div>{snackbarMessage.body}</div>
                    </div>
                }
                action={
                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            />
            {familyCardCreate &&
                <div className="lightbox-overlay">
                    <div className="lightbox-content">
                        <div className='d-flex align-items-center justify-content-between'>
                            <div className='d-flex align-items-center'>
                                <IconButton onClick={() => setFamilyCardCreate(false)}>
                                    <ArrowBackIcon />
                                </IconButton>
                                <h6 className='heading-fav text-left mb-0 ms-1'>Create Family Group</h6>
                            </div>
                            <IconButton onClick={() => setFamilyCardCreate(false)} sx={{ margin: 0, padding: 0 }}>
                                <CloseRoundedIcon />
                            </IconButton>
                        </div>

                        <div className='profile-and-logo my-4 mt-4 d-flex'>
                            <div className='preview-card-names profile-picture-container text-center'>
                                <h5>Group Picture</h5>
                                <div>
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                        badgeContent={
                                            <Avatar sx={{ bgcolor: "#0044C6" }}>
                                                <label htmlFor="profilePicture-input" style={{ cursor: "pointer", display: "flex" }}>
                                                    <AddCircleRoundedIcon />
                                                </label>
                                                <input
                                                    id="profilePicture-input"
                                                    type="file"
                                                    accept='image/*'
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileSelect}
                                                />
                                            </Avatar>
                                        }
                                    >
                                        <Avatar sx={{ bgcolor: "#F4F7FE", width: "130px", height: "130px" }}>
                                            {cardDetails.profilePic ?
                                                <img src={cardDetails.profilePic} alt="profile" className='profile-pic-avatar' />
                                                : <InsertPhotoIcon sx={{ color: "grey" }} fontSize="large" />
                                            }
                                        </Avatar>
                                    </Badge>
                                </div>
                            </div>

                            <div className='description-and-name flex-center flex-column ms-3 mt-2' style={{ width: "270px" }}>
                                <TextField
                                    className='textFieldWidthHeight'
                                    name="groupName"
                                    value={cardDetails.groupName}
                                    onChange={handleInputChange}
                                    placeholder="Group Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 20 }}
                                />
                                <TextField
                                    className='m-0 textFieldWidthHeight'
                                    name="description"
                                    value={cardDetails.description}
                                    onChange={handleInputChange}
                                    placeholder="Group Description"
                                    variant="outlined"
                                    multiline
                                    rows={2}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 20 }}
                                />
                            </div>
                        </div>

                        <div className='d-flex justify-content-end' style={{ marginTop: "16px" }}>
                            <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleCreateGroupCard} disabled={!isFormValid}>CREATE</Button>
                        </div>

                        {/* Crop Dialog */}
                        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                            <DialogTitle>Crop Image</DialogTitle>
                            <DialogContent>
                                {selectedImage && (
                                    <div style={{ width: '100%', minWidth: "200px", position: 'relative' }}>
                                        <ReactCrop
                                            crop={crop}
                                            onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
                                            circularCrop
                                            keepSelection
                                            aspect={ASPECT_RATIO}
                                            minWidth={MIN_DIMENSION}
                                        >
                                            <img ref={imgRef} src={selectedImage} onLoad={onImageLoad} alt="Crop preview" style={{ maxWidth: "100%" }} />
                                        </ReactCrop>
                                        <canvas ref={previewCanvasRef} style={{ display: 'none' }} />
                                    </div>
                                )}
                            </DialogContent>
                            <DialogContent>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "10px 0" }}>
                                    <Slider
                                        value={zoom}
                                        onChange={handleSliderChange}
                                        min={1}
                                        max={3}
                                        step={0.1}
                                        aria-labelledby="zoom-slider"
                                    />
                                </div>
                                <div className='d-flex justify-content-end' style={{ marginTop: "24px" }}>
                                    <Button onClick={() => setFamilyCardCreate(false)} className="delete-button_configuration me-3" sx={{ color: "#0044C6" }}>
                                        CANCEL
                                    </Button>
                                    <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleCropSave}>SAVE</Button>
                                </div>

                            </DialogContent>
                        </Dialog>
                    </div>
                </div>
            }
        </>
    );
};

export default LightBoxGroupCreate